export default function EventShareBox({ data, design }) {
    return design.element({ data });
}